<div class="isg-full-page-header">

  <div class="isg-page-header isg-toolbar">

    <a routerLink="/admin/license"
       [queryParams]="{ id: currentLicenseId }"
       class="isg-button-nav">
      <span class="fas fa-table" title="Back to licenses"></span>
    </a>

    <a routerLink="/admin/user/license"
       [queryParams]="{ id: currentLicenseId }"
       class="isg-button-nav">
      <span class="fas fa-user" title="License Users"></span>
    </a>

    <a routerLink="/admin/role"
       [queryParams]="{ id: currentLicenseId }"
       class="isg-button-nav">
      <span class="far fa-solid fa-gear" title="License Roles"></span>
    </a>

    <span>User Permissions for {{companyName}}</span>

  </div>

  <div class="isg-page-body" [style.height.px]="height">

    <div class="isg-user-auth-page" [class.isg-module-hide]="hideModule" [class.isg-datatree-hide]="hideAuthDataTree">

      <!-- users -->
      <div class="isg-user-auth-user-wrapper">

        <div class="isg-subheader">
          <span>Users</span>
        </div>
        <div class="isg-toolbar">

          <span>Licence Users</span>

          <button kendoButton type="button" class="isg-button-icon" (click)="onUpdateUserLicenseClick(true)">
            <span class="fas fa-plus" title="Add checked user(s) to license"></span>
          </button>

          <button kendoButton type="button" class="isg-button-icon" (click)="onUpdateUserLicenseClick(false)">
            <span class="fas fa-minus" title="Remove checked user(s) from license"></span>
          </button>

        </div>
        <app-user-list [moduleId]="currentModuleId"
                       [companyId]="currentCompanyId"
                       [showToolbar]="true"
                       [showLicenseFilter]="true"
                       [showCheckbox]="true"
                       [showLicensedIcon]="true"
                       [assignedTolicenseId]="currentLicenseId"
                       [widthThreshold]="1000"
                       (selected)="onUserSelected($event)"
                       [showLicenseUsersOnly]="true">
        </app-user-list>

      </div>

      <!-- modules / roles -->
      <div class="isg-user-auth-mod-roles-wrapper">

        <div [ngClass]="{'isg-module-hide': hideModule}">
          <div class="isg-subheader">
            <span>Modules</span>
          </div>
          <div class="isg-module-list">
            <app-modules-list [licenseId]="currentLicenseId"
                              [includeHost]="true"
                              [hasApi]="null"
                              [userId]="currentUserId"
                              [showCheckbox]="true"
                              [widthThreshold]="1000"
                              (selected)="onModuleSelected($event)"
                              (dataLoaded)="onModulesLoaded($event)">
            </app-modules-list>
          </div>
        </div>
        <div>
          <div class="isg-subheader">
            <span>Roles </span>
            <div class="isg-toolbar">

              <button *ngIf="showSaveUserRolesButton"
                      kendoButton type="button" class="isg-button-icon" (click)="onSaveUserRolesClick(1)">
                <span class="fas fa-plus" title="Add roles to checked user(s)"></span>
              </button>

              <button *ngIf="showSaveUserRolesButton"
                      kendoButton type="button" class="isg-button-icon" (click)="onSaveUserRolesClick(-1)">
                <span class="fas fa-minus" title="Remove roles from checked user(s)"></span>
              </button>

              <button *ngIf="showSaveUserRolesButton"
                      kendoButton type="button" class="isg-button-icon" (click)="onSaveUserRolesClick(0)">
                <span class="fas fa-floppy-disks" title="Set roles for checked user(s)"></span>
              </button>

            </div>
          </div>
          <div class="isg-role-list">
            <app-roles-list [moduleId]="currentModuleId"
                            [licenseId]="currentLicenseId"
                            [userId]="currentUserId"
                            [showToolbar]="false"
                            [showCheckbox]="true"
                            [showSaveButton]="showSaveUserRolesButton"
                            (selected)="onRoleSelected($event)">
            </app-roles-list>
          </div>
        </div>

      </div>

      <!-- menus / display-->
      <div class="isg-user-auth-tree-visual-wrapper">

        <div class="isg-subheader">
          <span>Menus/Display</span>
        </div>

        <div class="isg-role-auth-visual">
          <app-auth-tree #authtreevisual
                         [moduleIds]="[currentModuleId]"
                         [licenseId]="currentLicenseId"
                         [roleId]="currentRoleId"
                         [authTypes]="['M', 'V', 'PP']"
                         [active]="true"
                         [cascadeLink]="true"
                         [includeMembers]="false"
                         [includeHierarchies]="false"
                         [includeLabels]="true"
                         [showToolbar]="true"
                         [showSaveButton]="showSaveUserAuthsButton"
                         [showEditButton]="enablePermissionEdits"
                         [showReadOnlyButton]="!(enablePermissionEdits)"
                         [showReorderButton]="enablePermissionEdits"
                         [showDeleteButton]="enablePermissionEdits"
                         [enableSaveButton]="enableSavePermissions"
                         [widthThreshold]="1000"
                         (permissionsSavedChange)="onPermissionsChanged()">

          </app-auth-tree>
        </div>

      </div>

      <!-- data -->
      <div class="isg-user-auth-tree-data-wrapper" [ngClass]="{'isg-datatree-hide': hideAuthDataTree}" style="margin-left:24px;">

        <div class="isg-subheader">
          <span>Data</span>
        </div>

        <div class="isg-role-auth-data">
          <app-auth-tree #authtreedata
                         [moduleIds]="[currentModuleId]"
                         [licenseId]="currentLicenseId"
                         [roleId]="currentRoleId"
                         [authTypes]="['D', 'PBI']"
                         [active]="true"
                         [cascadeLink]="true"
                         [includeMembers]="false"
                         [includeHierarchies]="false"
                         [includeLabels]="true"
                         [showToolbar]="true"
                         [showSaveButton]="showSaveUserAuthsButton"
                         [showEditButton]="enablePermissionEdits"
                         [showReadOnlyButton]="!(enablePermissionEdits)"
                         [showReorderButton]="enablePermissionEdits"
                         [showDeleteButton]="enablePermissionEdits"
                         [widthThreshold]="1000"
                         (permissionsSavedChange)="onPermissionsChanged()"
                         (dataLoaded)="onDataTreeLoaded($event)">
          </app-auth-tree>
        </div>

      </div>

    </div>

  </div>

</div>
